import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";

class MemoDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _id: null,
            date: null,
            referenceNumber: null,
            subject: null,
            recipient: null
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.id) {
            this.setState({
                _id: match.params.id
            })
        }
    }

    goToList = () => {
        this.props.history.push(`/general-memos/list`)
    }

    render() {

        const { 
            _id,
            date,
            referenceNumber,
            subject,
            recipient
        } = this.state;

        return (
        <div className="content">
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Memo Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.goToList()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                    <div className="typo-line">
                        <div>
                        <p className="category">Memo ID</p>
                        {_id || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Date</p>
                        {date || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Ref #</p>
                        {referenceNumber || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Subject</p>
                        {subject || 'N/A'}
                        </div>
                    </div>
                    <div className="typo-line">
                        <div>
                        <p className="category">Recipient</p>
                        {recipient || 'N/A'}
                        </div>
                    </div>
                    </Col>
                </Row>
            </Grid>
        </div>
        );
    }
}

export default MemoDetails;
